import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'
import { useRevenueFee } from '~/@pages_investing/_utils/revenue-fee/useRevenueFee'
import { useFeeImmunity } from '~/@pages_investing/fee-immunity/useFeeImmunity'

export function ProjectYieldTooltip() {
  const { fee } = useRevenueFee()
  const { hasFeeImmunity } = useFeeImmunity()

  const suffix = hasFeeImmunity
    ? '.'
    : `, očistený od poplatku ${(fee * 100).toFixed(2)}%.`

  const tooltipText = `Tento údaj predstavuje ročný predpokladaný výnos, ktorý investor získa z investície do zaisteného úveru${suffix}`

  return <TextTooltip text={tooltipText} />
}
